import React from 'react';

const Sidebar = ({ isOpen, onClose, activeTab, setActiveTab, isAdmin, onLogout }) => {
  const navItems = [
    { id: 'dashboard', label: 'System Dashboard', icon: 'dashboard' },
    { id: 'matches', label: 'Match History', icon: 'sports_soccer' },
    { id: 'players', label: 'Squad Overview', icon: 'groups' },
    { id: 'goalkeeper', label: 'GK Analytics', icon: 'front_hand' },
  ];

  const adminItems = [
    { id: 'addMatch', label: 'Log Match', icon: 'add_box' },
    { id: 'teamgen', label: 'Algorithm Builder', icon: 'construction' },
    { id: 'settings', label: 'Global Settings', icon: 'settings' },
  ];

  const NavButton = ({ item }) => {
    const isActive = activeTab === item.id;
    return (
      <button
        onClick={() => { setActiveTab(item.id); onClose(); }}
        className={`w-full flex items-center gap-4 px-6 py-3.5 transition-all duration-200 font-manrope text-sm font-semibold active:scale-95 ${
          isActive 
            ? 'bg-primary/10 text-primary border-r-4 border-primary' 
            : 'text-stone-400 hover:text-on-background hover:bg-surface-container-high border-r-4 border-transparent'
        }`}
      >
        <span 
          className="material-symbols-outlined text-[22px]" 
          style={{ fontVariationSettings: isActive ? "'FILL' 1" : "'FILL' 0" }}
        >
          {item.icon}
        </span>
        {item.label}
      </button>
    );
  };

  return (
    <>
      {/* Mobile Backdrop Overlay */}
      {isOpen && (
        <div 
          className="fixed inset-0 bg-background/80 backdrop-blur-sm z-40 lg:hidden" 
          onClick={onClose} 
        />
      )}

      {/* Sidebar Container */}
      <aside 
        className={`fixed top-0 left-0 h-screen w-64 bg-surface-container-low border-r border-outline-variant/30 flex flex-col z-50 transition-transform duration-300 ${
          isOpen ? 'translate-x-0' : '-translate-x-full lg:translate-x-0'
        }`}
      >
        
        {/* Brand Header */}
        <div className="h-[76px] flex items-center px-6 border-b border-outline-variant/30">
          <div className="w-8 h-8 bg-primary rounded flex items-center justify-center mr-3 shadow-lg shadow-primary/20">
            <span className="material-symbols-outlined text-on-primary font-bold text-lg">sports_soccer</span>
          </div>
          <div>
            <h1 className="font-lexend font-black text-on-background text-lg leading-tight tracking-tight">Eclipse FC</h1>
            <p className="font-manrope text-[9px] text-primary tracking-[0.2em] uppercase font-bold mt-0.5">System Controller</p>
          </div>
        </div>

        {/* Navigation Links */}
        <nav className="flex-1 overflow-y-auto py-6 space-y-1 custom-scrollbar">
          <div className="px-6 mb-3">
            <p className="text-[10px] font-bold tracking-widest text-stone-500 uppercase font-lexend">Main Menu</p>
          </div>
          
          {navItems.map(item => <NavButton key={item.id} item={item} />)}

          {isAdmin && (
            <>
              <div className="px-6 mb-3 mt-8">
                <p className="text-[10px] font-bold tracking-widest text-stone-500 uppercase font-lexend">Admin Suite</p>
              </div>
              {adminItems.map(item => <NavButton key={item.id} item={item} />)}
            </>
          )}
        </nav>

        {/* Bottom Logout */}
        <div className="p-4 border-t border-outline-variant/30 bg-surface-container-low">
          <button 
            onClick={onLogout}
            className="w-full flex items-center justify-center gap-2 py-3 px-4 bg-surface-container-high border border-outline-variant/50 hover:bg-error/10 hover:border-error/30 hover:text-error text-stone-400 rounded-xl font-manrope text-sm font-bold transition-all active:scale-95"
          >
            <span className="material-symbols-outlined text-[20px]">logout</span>
            Terminate Session
          </button>
        </div>
      </aside>
    </>
  );
};

export default Sidebar;
